<template lang="html">
  <!-- Footer -->
  <footer id="page-footer" class="bg-body-light">
    <div class="content py-3">
      <div class="row font-size-sm">
        <div class="col-sm-6 order-sm-2 py-1 text-center text-sm-right">
          Crafted with <i class="fa fa-heart text-danger"></i> by <a class="font-w600" href="https://3dsinteractive.com"
                                                                     target="_blank">3DS INTERACTIVE</a>
        </div>
        <div class="col-sm-6 order-sm-1 py-1 text-center text-sm-left">
          <a class="font-w600" href="https://3dsinteractive.com" target="_blank">UNITY API PLATFORM</a> &copy; 2018-26
        </div>
      </div>
    </div>
  </footer>
  <!-- END Footer -->
</template>

<script>
  export default {}
</script>

<style lang="css">
</style>
